import { legoInit, legoPerf } from '@zz-common/lego'

import 'core-js/stable'
import 'regenerator-runtime/runtime'
import VueLazyLoad from 'vue-lazyload'
import '@zz/sasscore/flexible.js'
import { url, setPicSize, wxFontSizeAdapter } from '@zz-yp/hunter-js-utils'
import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import Directives from './directives'
import { adapter } from '@lib/decorator'
import { legic } from '@lib/legic'
import plugins from '@src/lib/plugins'
import zpmConfig from '../config/zpm-config'
import { initWxCookie } from '@/lib/miniAuth'

import { Button, Icon, Dialog, Toast, Stance, Popup, FixTop, Tab, Tabs } from '@zz-yp/hunter-ui'
import { fetch } from '@lib/axios'
import { SentryVueInit } from '@zz-common/sentry'

Vue.config.productionTip = false
initWxCookie()
const native = adapter()
Vue.filter('picFilter', function (url, width, height, options) {
  return setPicSize(url, width, height, options)
})
// 微信/小程序字体大小适配
wxFontSizeAdapter()
// 挂载在 Vue.prototype 上的全局属性/方法
Vue.use(plugins)
Object.defineProperty(Vue.prototype, '$native', {
  value: native,
  writable: true,
  enumerable: true,
  configurable: true
})

// 全局通用的
Vue.use(fetch)

Vue.use(Button)
  .use(Icon)
  .use(Dialog)
  .use(Toast)
  .use(Stance)
  .use(Popup)
  .use(Tab)
  .use(Tabs)
  .use(FixTop, { adapter: native })

// 全局自定义指令
Vue.use(Directives)

class __App__ {
  init() {
    // 推荐使用$legic
    Vue.prototype.$legic = legic
    Vue.prototype.$lego = function ({ actiontype, backup, pagetype }) {
      if (pagetype && typeof pagetype !== 'string') {
        return console.error('pagetype必须是字符串')
      }
      const channel = url.getParam('channel')
      legic(pagetype, actiontype, {
        ...backup,
        channel
      })
    }
    tryCatch(() => {
      // 全局初始化乐高埋点的值，默认合入backup
      legoInit(zpmConfig)
      // 开发环境不使用性能检测 和 sentry上报
      if (process.env.NODE_ENV === 'production') {
        // js异常上报
        SentryVueInit()
        try {
          // 性能检测域名黑名单
          const blackHostnameArr = ['m2.zhuanzhuan.com']
          // 是否为预渲染页面
          const isPreRender = url.getParam('isPreRender', location.href) == 1
          if (!blackHostnameArr.includes(location.hostname) && !isPreRender) {
            legoPerf()
          }
        } catch (err) {
          console.warn(err)
        }
      }
    })
    // 懒加载
    this.sueLazyLoad()
    // 注册vue实例
    this.mount()
  }

  mount() {
    window.vm = new Vue({
      // @ts-ignore
      router,
      store,
      render: (h) => h(App)
    }).$mount('#app')
  }

  sueLazyLoad() {
    tryCatch(function () {
      Vue.use(VueLazyLoad, {
        preLoad: 1.3,
        try: 2
      })
    })
  }
}

// 本地测试sentry时可按照这个格式进行本地调试
// SentryVueInit(
//   'https://e8d729b495a24447a64861e53e98b466@sentry.zhuanzhuan.com/1014',
//   {
//     senddev: true,
//     beforeSend: event => {
//       // console.log(event)
//       return event
//     }
//   }
// )
const app = new __App__()
app.init()

function tryCatch(fn) {
  try {
    fn()
  } catch (err) {
    console.error(err)
  }
}

// 业务代码
Vue.prototype.isMini = false
const isMini = () => {
  return new Promise((resolve, reject) => {
    native.asyncIn('wa', resolve, reject)
  })
}
isMini()
  .then(() => {
    Vue.prototype.isMini = true
  })
  .catch(() => {})
